<ion-header class="ion-no-border smr-client-detail-header" *ngIf="client">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
    <ion-title>
      {{ client.firstName }} {{ client.lastName }}
      <span class="pronouns"
        >{{ client.getReadablePronouns() ? "(" + client.getReadablePronouns() +
        ")" : "" }}</span
      >
    </ion-title>
  </ion-toolbar>
  <ion-toolbar class="ion-no-padding">
    <ion-buttons class="tab-group" *ngIf="windowWidth > 1024">
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-info' }"
        class="tab-button"
        (click)="tab = 'client-info'"
        >Details</ion-button
      >
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-photos' }"
        class="tab-button"
        (click)="tab = 'client-photos';"
        >Photos</ion-button
      >
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-bookings' }"
        class="tab-button"
        (click)="tab = 'client-bookings'"
        >Bookings</ion-button
      >
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-sales' }"
        class="tab-button"
        (click)="tab = 'client-sales'"
        >Sales</ion-button
      >
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-communications' }"
        class="tab-button"
        (click)="tab = 'client-communications'"
        >Communication</ion-button
      >
    </ion-buttons>

    <ion-buttons class="tab-group" *ngIf="windowWidth <= 1024">
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-info' }"
        class="tab-button"
        (click)="tab = 'client-info'"
        ><ion-icon name="information-circle"></ion-icon
      ></ion-button>
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-photos' }"
        class="tab-button"
        (click)="tab = 'client-photos';"
        ><ion-icon name="camera"></ion-icon
      ></ion-button>
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-bookings' }"
        class="tab-button"
        (click)="tab = 'client-bookings'"
        ><ion-icon name="calendar"></ion-icon
      ></ion-button>
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-sales' }"
        class="tab-button"
        (click)="tab = 'client-sales'"
        ><ion-icon name="card"></ion-icon
      ></ion-button>
      <ion-button
        [ngClass]="{ 'tab-checked': tab == 'client-communications' }"
        class="tab-button"
        (click)="tab = 'client-communications'"
        ><ion-icon name="chatbubbles"></ion-icon
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="client" class="smr-client-detail-content">
  <div [ngSwitch]="tab" class="summary-content">
    <smr-client-info
      *ngSwitchCase="'client-info'"
      [client]="client"
      [isReadOnly]="isReadOnly"
      (onClientUpdate)="updateClient($event)"
    >
    </smr-client-info>

    <ng-container *ngSwitchCase="'client-photos'">
      <div class="ion-text-center">
        <ion-spinner
          icon="crescent"
          color="primary"
          *ngIf="isLoadingPastBookings"
        ></ion-spinner>
        <ion-note *ngIf="errorOccurredWhileLoadingPastBookings"
          >Oops! An error occured.</ion-note
        >
      </div>

      <ng-container
        *ngIf="!isLoadingPastBookings && !errorOccurredWhileLoadingPastBookings"
      >
        <smr-booking-photos-manager
          [isReadOnly]="isReadOnly"
          [client]="client"
          (profilePhoto)="setProfilePhoto($event)"
        >
        </smr-booking-photos-manager>
      </ng-container>
    </ng-container>

    <smr-client-bookings
      *ngSwitchCase="'client-bookings'"
      [client]="client"
    ></smr-client-bookings>
    <smr-client-sales
      *ngSwitchCase="'client-sales'"
      [client]="client"
    ></smr-client-sales>
    <smr-client-communication-history-list
      *ngSwitchCase="'client-communications'"
      [client]="client"
    ></smr-client-communication-history-list>
  </div>

  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingClientDetails"
    (click)="loadClient()"
  ></salonmonster-tap-retry>
</ion-content>
<ion-footer class="smr-client-detail-footer">
  <ion-toolbar>
    <ion-grid class="submitButtons">
      <ion-row>
        <ion-col class="hidden-md-down" size="5"></ion-col>
        <ion-col>
          <ion-button
            fill="outline"
            expand="block"
            color="danger"
            [disabled]="isReadOnly"
            (click)="onClientDelete()"
          >
            Delete
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button fill="outline" expand="block" [disabled]="isReadOnly" (click)="onClientMerge()">
            Merge
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button fill="solid" expand="block" [disabled]="isReadOnly" (click)="edit()">
            Edit
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
